import { useParams } from "react-router-dom";
import { useOrganization } from "../../../../../hooks/query";

export default function useEditOrganization() {
    const { organizationId } = useParams<{ organizationId: string }>();
    const { useUpdate, useDescribe } = useOrganization();

    const editOrganizationSvc = useUpdate();
    const { data: organizationData, isLoading } = useDescribe(organizationId as string);

    const handleEditOrganization = async (data: any) => {
        try {
            const { LogoFile: _logoFile, ...payload } = data;
            await editOrganizationSvc.mutateAsync({ Id: organizationId, ...payload });
        } catch (error) {
            console.error("Failed to edit organization", error);
        }
    };

    return {
        editOrganizationSvc,
        handleEditOrganization,
        organizationData,
        isLoading,
    };
}
